import { LocationState, ProtectedIsSubscribedRouteProps, UserData } from "@/types";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../zustand/Zustand";
import LoadingScreen from "./LoadingScreen";

const ProtectedIsSubscribedRoute: React.FC<ProtectedIsSubscribedRouteProps> = ({
  children,
  redirectTo = "/subscription",
  fallback: FallbackComponent
}) => {
  const { userData, isAuthenticated } = useAuth() as { userData: UserData | null; isAuthenticated: boolean };
  const location = useLocation();

  // Not authenticated — redirect to login immediately
  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        state={{ from: location } as LocationState}
        replace
      />
    );
  }

  // Authenticated but userData not yet hydrated — wait
  if (!userData) {
    return <LoadingScreen />;
  }

  if (!userData.acceptedTerms) {
    if (FallbackComponent) {
      return <FallbackComponent />;
    }

    return (
      <Navigate
        to={"/accept-terms"}
        state={{ from: location } as LocationState}
        replace
      />
    );
  }

  if (!userData.hasAccess) {
    if (FallbackComponent) {
      return <FallbackComponent />;
    }

    return (
      <Navigate
        to={redirectTo}
        state={{ from: location } as LocationState}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default ProtectedIsSubscribedRoute;